import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPrivacy(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.5 4.7045C17.5 3.83712 16.9409 3.06861 16.1156 2.80161L9.61564 0.698673C9.21543 0.569192 8.78457 0.569192 8.38436 0.698674L1.88436 2.80161C1.0591 3.06861 0.5 3.83712 0.5 4.7045V9.91184C0.5 14.8843 5 17.4995 9 19.6574C13 17.4995 17.5 14.8843 17.5 9.91184V4.7045Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.2915C10.883 9.9057 11.5 9.02465 11.5 7.9995C11.5 6.61878 10.3807 5.4995 9 5.4995C7.61929 5.4995 6.5 6.61878 6.5 7.9995C6.5 9.02465 7.11705 9.9057 8 10.2915V12.4995C8 13.0518 8.44772 13.4995 9 13.4995C9.55228 13.4995 10 13.0518 10 12.4995V10.2915Z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const ForwardRef = forwardRef(SvgPrivacy);
export default ForwardRef;
